import React from 'react';
import { MapPin, Phone, Instagram, Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#003580] text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Logo and Description - LOGO EN TEXTO BLANCO SIN IMAGEN */}
          <div className="space-y-4">
            <div className="text-white">
              <div className="space-y-1">
                <h2 className="text-2xl font-bold tracking-wide">Andoviajando.com.ar</h2>
                <p className="text-xs font-light tracking-widest">TU VIAJE COMIENZA HOY</p>
              </div>
            </div>
            <div className="text-white space-y-2">
              <p className="font-bold text-lg">Andoviajando Adrogué</p>
              <p className="text-sm">Legajo 19092</p>
              <p className="text-sm leading-relaxed">
                Tu agencia de confianza para viajes de esquí en Argentina.
              </p>
              <p className="text-gray-300 text-xs">
                Your trusted agency for ski trips in Argentina.
              </p>
            </div>
          </div>

          {/* Contact Information */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-white mb-4">Contacto / Contact</h3>
            <div className="space-y-3 text-white">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-white flex-shrink-0 mt-1" />
                <div>
                  <p className="font-semibold">Domicilio:</p>
                  <p className="text-sm">
                    Pellerano 712 piso 2 dpto 13<br />
                    Adrogué, Buenos Aires, Argentina
                  </p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-white flex-shrink-0 mt-1" />
                <div className="space-y-1">
                  <div>
                    <p className="font-semibold text-sm">WhatsApp Guardia 24hs:</p>
                    <p className="text-white text-sm">
                      +54 9 11 3598 1641
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold text-sm">WhatsApp Agencia:</p>
                    <a 
                      href="https://wa.me/5491144273735?text=Hola!%20Vengo%20de%20la%20web%20de%20esquí" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="hover:text-[#FF6B35] transition-colors text-sm"
                    >
                      +54 9 11 4427 3735
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Social Media - CORREGIDO TEXTO FACEBOOK */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-white mb-4">Síguenos / Follow Us</h3>
            <div className="space-y-3">
              <a
                href="https://www.instagram.com/andoviajando.adrogue/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 text-white hover:text-[#FF6B35] transition-colors group"
              >
                <Instagram className="w-5 h-5 group-hover:scale-110 transition-transform" />
                <span>@andoviajando.adrogue</span>
              </a>
              <a
                href="https://www.facebook.com/andoviajandoadrogue/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 text-white hover:text-[#FF6B35] transition-colors group"
              >
                <Facebook className="w-5 h-5 group-hover:scale-110 transition-transform" />
                <span>Andoviajando Adrogué</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-6 mt-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white text-sm text-center md:text-left">
              © 2026 AndoViajando Adrogué - Legajo 19092. Andoviajando es una marca registrada. Todos los derechos reservados. / All rights reserved.
            </p>
            <p className="text-white text-sm text-center md:text-right">
              10 años creando experiencias inolvidables en la nieve
              <br />
              <span className="text-gray-300 text-xs">10 years creating unforgettable experiences in the snow</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
